// extracted by mini-css-extract-plugin
export default {"errorNotFountWrapper":"Page404_errorNotFountWrapper__Cqv4j","errorNotFount":"Page404_errorNotFount__Y3UtD"};